<script setup lang="ts">
import CkAvatar from './CkAvatar.vue'

defineProps<{ name: string; role: string }>()
</script>

<template>
  <div class="ck-user-card">
    <CkAvatar :name="name" :size="38" />
    <div><strong>{{ name }}</strong><span>{{ role }}</span></div>
  </div>
</template>

<style scoped>
.ck-user-card { display: flex; align-items: center; gap: 11px; }
.ck-user-card strong { display: block; font-size: 13.5px; font-weight: 700; color: var(--color-text); }
.ck-user-card span { display: block; font-size: 11.5px; color: var(--color-text-faint); }
</style>
